import { render, staticRenderFns } from "./StForm.vue?vue&type=template&id=6a003a8a"
import script from "./StForm.vue?vue&type=script&lang=ts"
export * from "./StForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports